import axios from 'axios';
import i18n from '../../i18next';
import MessageUtils from '../../utils/MessageUtils';
import { SERVER_URL } from '../../utils/Constants';

import {
    LOADING,
    GET_EVENT_TRACKING_LOG_SUCCESS,
    GET_SELECTED_USER_SUCCESS
} from '../types';
import { transformActionContent } from '../../utils/CommonUtils';

export const getEventTrackingLog = (pageNumber, searchQuery) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        let updatedSearchQuery = { ...searchQuery };

        const finalSearchQuery = getQueryParams(pageNumber, updatedSearchQuery);
        const url = `${SERVER_URL}/activity-log/search?${finalSearchQuery}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` } };

        axios.get(url, header)
            .then(res => getEventTrackingLogSuccess(res, dispatch, getState))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:eventTrackingActions.loadLogFailure')))
            //.finally(dispatch({ type: LOADING, payload: false }));
    }

}

const getEventTrackingLogSuccess = (res, dispatch, getState) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: GET_EVENT_TRACKING_LOG_SUCCESS, payload: res.data });  
}

export const downloadChanges = (activityId) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `${SERVER_URL}/activity-log/${activityId}/download-changes`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` }, responseType: 'arraybuffer' };

        axios.get(url, header)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                // Open the file for download
                let blob = new Blob([response.data], { type: 'application/zip' });
                let zipURL = window.URL.createObjectURL(blob);
                window.open(zipURL, '_blank');
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, error.response.data.userMessage);
            });
    };
};

export const getSelectedUser = (userId, callback) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        const url = `${SERVER_URL}/user/${userId}`;
        const header = { headers: { 'Authorization': `TOKEN${getState().user.token}` }};

        axios.get(url, header)
            .then(response => getSelectedUserSuccess(dispatch, response, callback))
            .catch(err => MessageUtils.errorMessageResponse(dispatch, err.response.data, i18n.t('actions:eventTrackingActions.loadUserFailure')))
            //.finally(dispatch({ type: LOADING, payload: false }));

    }
}

const getSelectedUserSuccess = (dispatch, response, callback) => {

    dispatch({ type: GET_SELECTED_USER_SUCCESS, payload: response.data });
    dispatch({ type: LOADING, payload: false });

    if(callback){
        callback();
    }
}

const getQueryParams = (pageNumber, searchQuery) => {
    const {
        restaurantId,
        actionType,
        userName,
        date
    } = searchQuery;
    let pageParam = '',
        sizeParam = '',
        restaurantIdParam = '',
        actionTypeParam = '',
        userNameParam = '',
        dateParam = ''
    pageParam = pageNumber;
    sizeParam = 10; // backend default 20


    if (restaurantId) {
        restaurantIdParam = `&restaurantId=${restaurantId}`
    }

    if (actionType) {
        let actionTypeId = transformActionContent(actionType)
        actionTypeParam = `&action=${actionTypeId}`
    }

    if (userName) {
        userNameParam = `&userName=${userName}`
    }

    if (date && date !== 'Invalid date') {
        dateParam = `&date=${date}`
    }

    return `page=${pageParam}&size=${sizeParam}${restaurantIdParam}${actionTypeParam}${userNameParam}${dateParam}`;
}


// WEBPACK FOOTER //
// ./src/actions/eventTracking/EventTrackingAction.js